<template>
	<div class="content" style="padding-top: 100px">
    <div>
      <h1>Welcome to AnnoAnno</h1>
      <div class="fp-links">
        <div
          class="fp-link"
          v-on:click="$router.push(link.url)"
          v-for="link in links">
          <div>
            <SvgIcon :name="link.icon" :size="60" />
            <div class="link-name">{{ link.name }}</div>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
  export default {
    data: () => ({
      links: [
        {
          name: 'Stylings',
          icon: 'styling',
          url: '/scheduled-calls/stylist'
        },
        {
          name: 'Translations',
          icon: 'feedback',
          url: '/translations'
        },
        {
          name: 'Email templates',
          icon: 'email',
          url: '/email-templates'
        }
      ]
    })
  }
</script>

<style lang="less" scoped>
  h1 {
    text-align: center;
    width: 100%;
    font-size: 40px;
    font-weight: 900;
    margin-bottom: 50px;
  }
  .fp-links {
    display: flex;
    justify-content: center;
  }
  .fp-link {
    text-align: center;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: 8px;
    width: 240px;
    height: 160px;
    background: linear-gradient(45deg, #eee, #efefef);
    border: 1px solid #ddd;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .link-name {
      margin-top: 5px;
      font-weight: 700;
      font-size: 18px;
    }
  }
</style>
